import Index from '../../views/issues/Index.vue';

export default [
  {
    path: '/issues',
    name: 'issues',
    component: Index,
    meta: {
      can: 'view issue',
      breadcrumb: [
        { name: '問題件紀錄', route: "issues" }
      ]
    }
  },
]
